import { EventEmitter } from "eventemitter3";
export class MagEventChannel extends EventEmitter {
    baseUrl;
    attempts = 0;
    maxAttempts;
    token;
    backoffFactor;
    backoffBase;
    closePromise;
    _state;
    constructor(baseUrl, token, maxReconnectAttempts = 15, backoffFactor = 1.618, backoffBase = 500.0) {
        super();
        this.baseUrl = baseUrl;
        this.token = token;
        this.maxAttempts = maxReconnectAttempts;
        this.backoffFactor = backoffFactor;
        this.backoffBase = backoffBase;
        this._state = "initial";
        this.updateState("initial");
        this.closePromise = new Promise((resolve) => {
            this.on("close", resolve);
        });
        if (this.token === null) {
            return;
        }
        this.connect().then();
    }
    useFiltered(messageType, listener) {
        const cb = (val) => {
            if (val.type != messageType)
                return;
            listener(val.body);
        };
        this.on("message", cb);
        return cb;
    }
    get state() {
        return this._state;
    }
    updateState(state) {
        this._state = state;
        this.emit("stateChange", state);
    }
    async connect() {
        if (this.attempts >= this.maxAttempts) {
            this.updateState("failed");
            return;
        }
        const authorization = this.token ? `Bearer ${this.token}` : undefined;
        const baseUrl = this.baseUrl.replace(/\/+$/, "");
        const response = await fetch(`${baseUrl}/streaming`, {
            method: "GET",
            headers: authorization ? { authorization } : {},
            credentials: "omit",
            cache: "no-cache",
        }).catch((e) => {
            console.error(e);
            return null;
        });
        if (response === null ||
            response.status >= 500 ||
            response.body === null) {
            this.updateState("exponentialBackoff");
            setTimeout(() => this.connect(), this.backoffBase * Math.pow(this.backoffFactor, this.attempts));
            this.attempts++;
            return;
        }
        if (response.status >= 400 && response.status < 500) {
            this.updateState("failed");
            return;
        }
        this.attempts = 0;
        const decoderStream = new TextDecoderStream();
        const reader = response.body.pipeThrough(decoderStream).getReader();
        this.updateState("connected");
        let buf = "";
        while (true) {
            const res = await Promise.race([
                reader.read().catch((e) => {
                    console.error(e);
                    return {
                        done: true,
                        value: undefined,
                    };
                }),
                this.closePromise,
            ]);
            if (res === "cancelled")
                break;
            if (res.done) {
                this.updateState("exponentialBackoff");
                setTimeout(() => this.connect(), this.backoffBase *
                    Math.pow(this.backoffFactor, this.attempts));
                this.attempts++;
                break;
            }
            buf += res.value;
            const splitIndex = buf.indexOf("\n\n");
            if (splitIndex === -1) {
                continue;
            }
            const rawValue = buf.substring(0, splitIndex);
            buf = buf.substring(splitIndex + 2);
            if (rawValue.startsWith(":"))
                continue;
            const text = rawValue
                .split("\n")
                .filter((l) => l.startsWith("data: "))
                .map((l) => l.substring("data: ".length))
                .join("\n");
            if (!text)
                continue;
            const data = JSON.parse(text);
            this.emit("message", data);
        }
        this.updateState("closed");
    }
    async close() {
        this.emit("close", "cancelled");
        this.off("message");
    }
}
//# sourceMappingURL=sse-listener.js.map